import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../../../components/buttons/buttons";
import Input from "../../../../components/inputs/inputs";
import { cleanInput } from "../../../../helpers/cleanInput";
import { Beat } from "../../../../plugins/spinners.plugin";
import {
  showApplication,
  updateApplication,
} from "../../../../redux/applicationSettings/applicationAction";
import DeliveryRange from "../DeliveryRange";

export default function ApplicationSettings() {
  const dispatch = useDispatch();
  const { updating, settings } = useSelector((state) => state.application);

  const [data, setData] = useState({
    restaurant_operating_status: settings?.restaurant_operating_status,
    store_operating_status: settings?.store_operating_status,
    multiple_outlet_checkout_status: settings?.multiple_outlet_checkout_status,
    pay_stack_payment_status: settings?.pay_stack_payment_status,
    flutter_wave_payment_status: settings?.flutter_wave_payment_status,
    ogwugo_payment_status: settings?.ogwugo_payment_status,
    opay_payment_status: settings?.opay_payment_status,
    automatic_shipping_status: settings?.automatic_shipping_status,
    package_delivery_periods: settings?.package_delivery_periods,
    operating_time_checkout_status: settings?.operating_time_checkout_status,
    // platform_charges: settings?.platform_charges || {
    //   service_fee: {
    //     percentage: "",
    //     status: "",
    //     minimum_limit: "",
    //     maximum_limit: "",
    //   },
    // },
    platform_charges: {
      service_fee: {
        percentage: settings?.platform_charges?.service_fee?.percentage || "",
        status: settings?.platform_charges?.service_fee?.status || "",
        minimum_limit:
          settings?.platform_charges?.service_fee?.minimum_limit || "",
        maximum_limit:
          settings?.platform_charges?.service_fee?.maximum_limit || "",
      },
    },
  });

  useEffect(() => {
    dispatch(showApplication());
  }, [dispatch]);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name === "service_fee_percentage") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            percentage: value,
          },
        },
      }));
    } else if (name === "service_fee_limit_min") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            minimum_limit: value,
          },
        },
      }));
    } else if (name === "service_fee_limit_max") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            maximum_limit: value,
          },
        },
      }));
    } else if (name === "service_fee_status") {
      setData((prev) => ({
        ...prev,
        platform_charges: {
          ...prev["platform_charges"],
          service_fee: {
            ...prev.platform_charges.service_fee,
            status: value,
          },
        },
      }));
    } else {
      setData({ ...data, [name]: value });
    }
  };

  const handleUpdate = async () => {
    cleanInput(data);
    const response = dispatch(updateApplication({ ...data }));
    if (response.status === "success") {
      dispatch(showApplication());
    }
  };

  return (
    <>
      <div className="w-100 mx-auto">
        <div className="mx-auto bg-white dark:bg-[#121212] sm:w-[630px] w-full mt-10 sm:mt-0 sm:border p-6 sm:border-gray-200 dark:border-none">
          <div className="border-b-2 dark:border-[#505050] py-4 mb-6">
            <p className=" text-base font-medium text-gray-800 dark:text-white flex justify-center ">
              Application Settings
            </p>
          </div>

          <form>
            <div className=" sm:px-10 mb-10">
              <Input.Select
                title={" All Restaurant Operating Status"}
                name="restaurant_operating_status"
                htmlFor={"restaurant_operating_status"}
                defaultValue={settings?.restaurant_operating_status}
                onChange={handleChange}
              >
                <option>Select option</option>
                <option value={"available"}>Available</option>
                <option value={"unavailable"}>Unavailable</option>
              </Input.Select>
              <Input.Select
                title={" All Store Operating Status"}
                name="store_operating_status"
                htmlFor={"store_operating_status"}
                defaultValue={settings?.store_operating_status || ""}
                onChange={handleChange}
              >
                <option>Select option</option>
                <option value={"available"}>Available</option>
                <option value={"unavailable"}>Unavailable</option>
              </Input.Select>
              <Input.Select
                title={" Multiple Store Checkout"}
                name="multiple_outlet_checkout_status"
                htmlFor={"multiple_outlet_checkout_status"}
                defaultValue={settings?.multiple_outlet_checkout_status}
                onChange={handleChange}
              >
                <option>Select option</option>
                <option value={"available"}>Available</option>
                <option value={"unavailable"}>Unavailable</option>
              </Input.Select>
              <Input.Select
                title={"Operating Time Checkout Status"}
                name="operating_time_checkout_status"
                htmlFor={"operating_time_checkout_status"}
                defaultValue={settings?.operating_time_checkout_status}
                onChange={handleChange}
              >
                <option>Select option</option>
                <option value={"available"}>Available</option>
                <option value={"unavailable"}>Unavailable</option>
              </Input.Select>
              <Input.Select
                title={"Automatic Shipping Status"}
                name="automatic_shipping_status"
                htmlFor={"automatic_shipping_status"}
                defaultValue={settings?.automatic_shipping_status}
                onChange={handleChange}
              >
                <option>Select option</option>
                <option value={"unavailable"}>Unavailable</option>
                <option value={"available"}>Available</option>
              </Input.Select>
              <Input.Select
                title={"Paystack Payment Method"}
                name="pay_stack_payment_status"
                htmlFor={"pay_stack_payment_status"}
                defaultValue={settings?.pay_stack_payment_status}
                onChange={handleChange}
              >
                <option>Select option</option>
                <option value={"available"}>Available</option>
                <option value={"unavailable"}>Unavailable</option>
              </Input.Select>
              <Input.Select
                title={"Ogwugo Payment Method"}
                name="ogwugo_payment_status"
                htmlFor={"ogwugo_payment_status"}
                defaultValue={settings?.ogwugo_payment_status}
                onChange={handleChange}
              >
                <option>Select option</option>
                <option value={"available"}>Available</option>
                <option value={"unavailable"}>Unavailable</option>
              </Input.Select>
              <Input.Select
                title={"Flutterwave Payment Method"}
                name="flutter_wave_payment_status"
                htmlFor={"flutter_wave_payment_status"}
                defaultValue={settings?.flutter_wave_payment_status}
                onChange={handleChange}
              >
                <option>Select option</option>
                <option value={"available"}>Available</option>
                <option value={"unavailable"}>Unavailable</option>
              </Input.Select>
              <Input.Select
                title={"Opay Payment Method"}
                name="opay_payment_status"
                htmlFor={"opay_payment_status"}
                defaultValue={settings?.opay_payment_status}
                onChange={handleChange}
              >
                <option>Select option</option>
                <option value={"available"}>Available</option>
                <option value={"unavailable"}>Unavailable</option>
              </Input.Select>
               <Input.Select
                  title={"Delivery Mode Checkout Status"}
                  name="delivery_mode_checkout_status"
                  htmlFor={"delivery_mode_checkout_status"}
                  defaultValue={settings?.platform_charges?.delivery_mode_checkout_status}
                  onChange={handleChange}
                >
                  <option>Select option</option>
                  <option value={"available"}>Available</option>
                  <option value={"unavailable"}>Unavailable</option>
                </Input.Select>
              <div className="grid sm:grid-cols-2 sm:gap-4">
                <Input.Number
                  title={"Service Fee Percentage"}
                  htmlFor={"service_fee_percentage"}
                  name={"service_fee_percentage"}
                  onChange={handleChange}
                  defaultValue={
                    settings?.platform_charges?.service_fee?.percentage
                  }
                  placeholder={"0.0"}
                />
                <Input.Select
                  title={"Service Fee Status"}
                  name="service_fee_status"
                  htmlFor={"service_fee_status"}
                  defaultValue={settings?.platform_charges?.service_fee?.status}
                  onChange={handleChange}
                >
                  <option>Select option</option>
                  <option value={"available"}>Available</option>
                  <option value={"unavailable"}>Unavailable</option>
                </Input.Select>
              </div>
              <div className="grid sm:grid-cols-2 sm:gap-4">
                <Input.Number
                  title={"Service Fee Limit (Mininum)"}
                  htmlFor={"service_fee_limit_min"}
                  name={"service_fee_limit_min"}
                  onChange={handleChange}
                  defaultValue={
                    settings?.platform_charges?.service_fee?.minimum_limit
                  }
                  placeholder={"0"}
                />
                <Input.Number
                  title={"Service Fee Limit(Maximum)"}
                  htmlFor={"service_fee_limit_max"}
                  name={"service_fee_limit_max"}
                  onChange={handleChange}
                  defaultValue={
                    settings?.platform_charges?.service_fee?.maximum_limit
                  }
                  placeholder={"0"}
                />
              </div>
              {/* Delivery time ranges */}
              {settings?.package_delivery_periods &&
                Object.keys(settings?.package_delivery_periods)?.map(
                  (period, index) => (
                    <DeliveryRange
                      key={index}
                      period={period}
                      settings={settings}
                      data={data}
                      setData={setData}
                    />
                  )
                )}
            </div>
          </form>
        </div>
      </div>
      <div className="flex justify-center mx-auto">
        <Button.Primary
          disabled={updating}
          title={updating ? <Beat color={"#ffffff"} /> : "Update Settings"}
          className={"px-4 rounded-sm sm:mt-10"}
          onClick={handleUpdate}
        />
      </div>
    </>
  );
}
